<template>
  <primary-sidebar></primary-sidebar>
</template>

<script lang="ts">
  import Vue from "vue";
  import PrimarySidebar from './components/primary-sidebar.vue';

  export default Vue.extend({
    components: {PrimarySidebar},
  });
</script>